<template>
  <!--  메인  -->
  <div id="main_area">
    <!-- <event-popup /> -->
    <component :is="evenTPopupCp" />
    <vueper-slides :touchable="false" autoplay>
      <vueper-slide
        v-for="(slide, index) in slideList"
        :key="index"
        :title="slide.title"
        :content="slide.content"
        :image="slide.image"
      >
        <div slot="slideContent">
          <v-layout>
            <div>
              <div>{{ slide.title }}</div>
              <div>{{ slide.content }}</div>
            </div>
          </v-layout>
        </div>
      </vueper-slide>
    </vueper-slides>

    <!--  메인 콘텐츠-->
    <div class="main">
      <!--main_visual-->
      <div class="main_contents">
        <ul>
          <li>
            <router-link to="/Biz/Club">
              <i class="CLUB"></i>
              <div class="txt">
                <p class="tit">FERRUM CLUB</p>
                <p>자세히 보기</p>
              </div>
            </router-link>
          </li>
          <li>
            <router-link to="/Biz/MRO">
              <i class="MRO"></i>
              <div class="txt">
                <p class="tit">MRO</p>
                <p>자세히 보기</p>
              </div>
            </router-link>
          </li>
          <li>
            <router-link to="/Biz/Tower">
              <i class="HALL"></i>
              <div class="txt">
                <p class="tit">FERRUM HALL</p>
                <p>자세히 보기</p>
              </div>
            </router-link>
          </li>
          <li>
            <router-link to="/Company/Principle">
              <div class="txt">
                <p class="tit">페럼인프라 소개</p>
                <span>+</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import EventPopup from "./EventPopup";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  components: { VueperSlides, VueperSlide, EventPopup },
  data: () => ({
    evenTPopupCp: null,
    message: "MainPage.vue",
    slideList: [
      {
        title: "<h2 class='main_txt_01'></h2>",
        content: "",
        // "＂고객 가치 창출과 공급사와의 협력을 통한 경쟁력 강화를 이루어낼 <br> 새로운 Innovative Procurement 시대를 열어 가겠습니다!＂",
        image: require("./../../assets/img/main/main_bg01.png")
      },
      {
        title: "<h2 class='main_txt_02'></h2>",
        content: "",
        image: require("./../../assets/img/main/main_bg02.jpg")
      },
      {
        title: "<h2 class='main_txt_03'></h2>",
        content: "",
        image: require("./../../assets/img/main/main_bg03.png")
      }
    ]
  }),
  methods: {},
  computed: {},
  mounted() {
    setTimeout(() => {
      if (this.evenTPopupCp == null) {
        this.evenTPopupCp = "event-popup";
      }
    }, 2000);
  },
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/MainPage.vue